import { DriverFormValues } from "../components";
import { DriverCertificateType } from "./enums";

export * from "./enums";
export * from "./cutoffSchedule";

export const EMPTY_DRIVER_FORM_VALUES: DriverFormValues = {
  priority: 1,
  capacity: 0,
  phoneNumber: "",
  firstname: "",
  lastname: "",
  birthdate: null,
  address: "",
  isActive: false,
  driverLicense: {
    type: DriverCertificateType.DriverLicense,
    reference: "",
    images: []
  },
  insurance: {
    type: DriverCertificateType.Insurance,
    reference: "",
    images: []
  },
  idLicense: {
    type: DriverCertificateType.Id,
    reference: "",
    images: []
  },
  vehicle: {
    type: DriverCertificateType.Vehicle,
    reference: "",
    images: []
  },
  password: "",
  repeatPassword: "",
  totalCargoVolume: 0,
  totalCargoWeight: 0,
  deliveryZones: [],
  image: null,
  deliveryCompanyId: null
};
